var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "authorize-plan-authority" }, [_c('div', { staticClass: "label" }, [_vm._v("可选功能权限:")]), _vm._v(" "), _vm._l(_vm.allPermissionOptions, function (item, index) {
    return _c('el-form-item', { key: index, attrs: { "label": item.label, "prop": item.prop } }, [_c('el-checkbox-group', { attrs: { "disabled": _vm.checkDisabled() }, model: { value: _vm.formValue.checkPermissions, callback: function callback($$v) {
          _vm.$set(_vm.formValue, "checkPermissions", $$v);
        }, expression: "formValue.checkPermissions" } }, _vm._l(item.children, function (item) {
      return _c('el-checkbox', { key: item.value, attrs: { "label": item.value, "disabled": item.value === _vm.PermissionKey.ai } }, [_vm._v(_vm._s(item.label))]);
    }), 1)], 1);
  })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };